<template>
	<div class="element downloads row">
		<div class="col-6">
			<AssetField name="asset_select" label="Asset" v-model="selectedAsset"/>
		</div>
		<div class="col-6">
			<Field
				type="select"
				label="Visibility"
				name="visibility_select"
				v-model="selectedVisibility"
				:options="visibilities"
				:hideSelectEmptyOption="true"
			/>
			<button type="button" role="button" class="btn btn-info mt-3 w-50" @click.prevent="add">Attach</button>
		</div>
		<div v-if="assigned.length > 0" class="col-12 mt-3 multi-assign-values">
			<a v-for="(item, i) in assigned" :key="i" class="pill" href="#" @click.prevent="remove(item)">
				<span class="text">{{ `${item.label} (${visibilityLabel(item)})` }}</span>
				<icon icon="remove" class="icon"/>
				<input type="hidden" :name="`${name}[${i}][asset_id]`" :value="item.asset_id"/>
				<input type="hidden" :name="`${name}[${i}][visibility]`" :value="item.visibility"/>
			</a>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		name: {type: String, default: "downloads"},
		value: {type: Array, default: () => []},
		visibilities: {type: Array, required: true}
	},
	data() {
		return {
			selectedAsset: null,
			selectedVisibility: this.$root.constants.PUBLIC_DOWNLOAD,
			assigned: [],
			assetCount: 0
		};
	},
	watch: {
		value(val) {
			if (_.isEmpty(val) || val.length !== this.assetCount)
				return;

			this.assigned = val;
		},
		assigned(val) {
			this.$emit("input", val);
		}
	},
	methods: {
		visibilityLabel(item) {
			var visibility = this.visibilities.find(v => v.value == item.visibility);
			return !!visibility ? visibility.label : "Everyone";
		},
		isAssigned(item) {
			return this.assigned.find(a => a.asset_id == item.asset_id) || false;
		},
		add() {
			if (!this.selectedAsset || !this.selectedVisibility) {
				alert("Please choose an asset and a visibility before continuing.");
				return;
			}
			var item = {
				asset_id: this.selectedAsset.id,
				visibility: this.selectedVisibility,
				label: this.selectedAsset.name
			};
			if (this.isAssigned(item)) {
				alert("You have already assigned the selected asset.");
				return;
			}
			this.assetCount += 1;
			this.assigned.push(item);
			this.reset();
		},
		remove(item) {
			let assigned = this.assigned;
			this.assigned = [];
			this.assetCount > 0 ? this.assetCount -= 1 : 0;
			this.assigned = assigned.filter(a => {
				return a.asset_id != item.asset_id;
			});
		},
		reset() {
			this.selectedAsset = null;
			this.selectedVisibility = this.$root.constants.PUBLIC_DOWNLOAD;
		}
	},
	mounted() {
		this.assigned = this.value;
		this.assetCount = this.value.length;
	}
};
</script>